import type { ReactNode } from 'react';

export const symbol_wand_shine: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M258.5-812q12.5 0 21.5 9l83 84q9 9 8.5 21t-9.5 21q-9 8-21 8.5t-21-8.5l-83-83q-9-9-9-21.5t9-21.5q9-9 21.5-9Zm283-95.5Q550-899 550-886v110q0 13-8.5 21.5T520-746q-13 0-21.5-8.5T490-776v-110q0-13 8.5-21.5T520-916q13 0 21.5 8.5Zm157 535.5q12.5 0 21.5 9l83 84q9 9 8.5 21t-9.5 21q-9 8-21 8.5t-21-8.5l-83-83q-9-9-9-21.5t9-21.5q9-9 21.5-9ZM802-771.5q0 12.5-9 21.5l-64 64q-9 9-21 8.5t-21-9.5q-9-9-9-21.5t9-21.5l63-63q9-9 21.5-9t21.5 9q9 9 9 21.5Zm105.5 273Q899-490 886-490H776q-13 0-21.5-8.5T746-520q0-13 8.5-21.5T776-550h110q13 0 21.5 8.5T916-520q0 13-8.5 21.5ZM212-85 85-212q-9-9-9-21t9-21l370-371q35-35 85-35t85 35q35 35 35 85t-35 85L254-85q-9 9-21 9t-21-9Zm300-342-21-21-21-21-21.5-21-21.5-21 43 42 42 42ZM233-148l279-279-85-84-278 278 84 85Z"
		/>
	</svg>
);
